import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";

import collectionService from "./collectionService";
import {
  CollectionDto,
  TaskInCollectionDto,
  RemoveTaskFromCollectionAnserDto,
  UpdatedNoteInCollectionDto,
  UpdateCollectionDto,
} from "./collection.types";

export const createQuickCollection = createAsyncThunk<
  CollectionDto,
  void,
  { state: RootState }
>("tasks/createQuickCollection", async (_, thunkAPI) => {
  try {
    return await collectionService.createQuickCollection();
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();
    console.error(message);
    return thunkAPI.rejectWithValue(message);
  }
});

export const addTaskToCollection = createAsyncThunk<
  TaskInCollectionDto,
  { taskId: string; collectionId: string },
  { state: RootState }
>("tasks/addTaskToCollection", async ({ taskId, collectionId }, thunkAPI) => {
  try {
    return await collectionService.addTaskToCollection(taskId, collectionId);
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();
    console.error(message);
    return thunkAPI.rejectWithValue(message);
  }
});

export const removeTaskFromCollection = createAsyncThunk<
  RemoveTaskFromCollectionAnserDto,
  { taskId: string; collectionId: string },
  { state: RootState }
>(
  "tasks/removeTaskFromCollection",
  async ({ taskId, collectionId }, thunkAPI) => {
    try {
      return await collectionService.removeTaskFromCollection(
        taskId,
        collectionId,
      );
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      console.error(message);
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const getCollections = createAsyncThunk<
  CollectionDto[],
  { groupId?: string; organizationId?: string },
  { state: RootState }
>("tasks/getCollections", async ({ groupId, organizationId }, thunkAPI) => {
  try {
    return await collectionService.getCollections(groupId, organizationId);
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();
    console.error(message);
    return thunkAPI.rejectWithValue(message);
  }
});

/**
 * Get a specific collection by ID
 */
export const getCollection = createAsyncThunk<
  CollectionDto,
  string,
  { state: RootState }
>("tasks/getCollection", async (collectionId, thunkAPI) => {
  try {
    return await collectionService.getCollection(collectionId);
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();
    console.error(message);
    return thunkAPI.rejectWithValue(message);
  }
});

export const deleteCollection = createAsyncThunk<
  string,
  string,
  { state: RootState }
>("tasks/deleteCollection", async (collectionId, thunkAPI) => {
  try {
    return await collectionService.deleteCollection(collectionId);
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();
    console.error(message);
    return thunkAPI.rejectWithValue(message);
  }
});

export const updateCollection = createAsyncThunk<
  CollectionDto,
  UpdateCollectionDto,
  { state: RootState }
>("tasks/updateCollection", async (updateCollectionData, thunkAPI) => {
  try {
    return await collectionService.updateCollection(updateCollectionData);
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();
    console.error(message);
    return thunkAPI.rejectWithValue(message);
  }
});

export const updateNotePositionsInCollection = createAsyncThunk<
  { updatedNotes: UpdatedNoteInCollectionDto[]; collectionId: string },
  { updatedNotes: UpdatedNoteInCollectionDto[]; collectionId: string },
  { state: RootState }
>(
  "tasks/updateNotePositionsInCollection",
  async ({ updatedNotes, collectionId }, thunkAPI) => {
    try {
      return {
        updatedNotes: await collectionService.updateNotePositionsInCollection(
          updatedNotes,
          collectionId,
        ),
        collectionId: collectionId,
      };
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      console.error(message);
      return thunkAPI.rejectWithValue(message);
    }
  },
);
